import { useNavigate } from "react-router-dom";
import { Button } from "../../../components/button/button";
import Title from "../../../components/texts/title";
import { _sizeHeading, _style } from "../../../core/core";

interface AdminMenuProps {
  isLink?: boolean;
  onOrdersClick?: () => void;
  onUsersClick?: () => void;
  onBansClick?: () => void;
  onTicketsClick?: () => void;
  onJobsClick?: () => void;
}

export const AdminMenu = ({
  isLink = true,
  onOrdersClick,
  onUsersClick,
  onBansClick,
  onTicketsClick,
  onJobsClick,
}: AdminMenuProps) => {
  const navigate = useNavigate();

  const handleAction = (callback?: () => void) => {
    if (callback) {
      callback();
    } else if (isLink) {
      navigate("/admin/");
    }
  };

  return (
    <div className="menu">
      <div className="menu-body">
        <Title type={_sizeHeading.h3}>Меню</Title>
        <Button
          style={_style.outline}
          width="100%"
          onClick={() => handleAction(onOrdersClick)}
        >
          Заказы
        </Button>
        <Button
          style={_style.outline}
          width="100%"
          onClick={() => handleAction(onUsersClick)}
        >
          Пользователи
        </Button>
        <Button
          style={_style.outline}
          width="100%"
          onClick={() => handleAction(onBansClick)}
        >
          Блокировки
        </Button>
        <Button
          style={_style.outline}
          width="100%"
          onClick={() => handleAction(onTicketsClick)}
        >
          Обращения
        </Button>
        {onJobsClick && (
          <Button
            style={_style.outline}
            width="100%"
            onClick={() => handleAction(onJobsClick)}
          >
            Задания
          </Button>
        )}
      </div>
    </div>
  );
};
